// Author Lin
// Date 2021-10-05 13:16:22

class MintalMesPrdSmeltingElectrodeDischarge {
constructor({
        id = null,
        productionDate = '',
        locationId = '',
        furnaceId = '',
        shiftId = '',
        avgPowerCost = '',
        tubeFeed1 = '',
        tubeFeed2 = '',
        tubeFeed3 = '',
        electrodeDiff1 = '',
        electrodeDischarge1 = '',
        electrodeDiff2 = '',
        electrodeDischarge2 = '',
        electrodeDiff3 = '',
        electrodeDischarge3 = '',
        bottomTemp12Start = '',
        bottomTemp12End = '',
        bottomTemp12Diff = '',
        bottomTemp22Start = '',
        bottomTemp22End = '',
        bottomTemp22Diff = '',
        bottomTemp32Start = '',
        bottomTemp32End = '',
        bottomTemp32Diff = '',
        envTempStart = '',
        envTempEnd = '',
        envTempDiff = '',
        coverTemp414Start = '',
        coverTemp414End = '',
        coverTemp414Diff = '',
        coverTemp424Start = '',
        coverTemp424End = '',
        coverTemp424Diff = '',
        coverTemp434Start = '',
        coverTemp434End = '',
        coverTemp434Diff = '',
        tapholeTemp150Start = '',
        tapholeTemp150End = '',
        tapholeTemp150Diff = '',
        tapholeTemp152Start = '',
        tapholeTemp152End = '',
        tapholeTemp152Diff = '',
        tapholeTemp153Start = '',
        tapholeTemp153End = '',
        tapholeTemp153Diff = '',
        tapholeTemp155Start = '',
        tapholeTemp155End = '',
        tapholeTemp155Diff = '',
        slagTemp250 = '',
        slagTemp251 = '',
        slagTemp252 = '',
        slagTemp253 = '',
        slagTemp254 = '',
        slagTemp255 = '',
        ironTemp131Start = '',
        ironTemp131End = '',
        ironTemp131Diff = '',
        ironTemp132Start = '',
        ironTemp132End = '',
        ironTemp132Diff = '',
        ironTemp133Start = '',
        ironTemp133End = '',
        ironTemp133Diff = '',
        drillDepth1 = '',
        oxygenTube1 = '',
        slagStatus1 = '',
        drillDepth2 = '',
        oxygenTube2 = '',
        slagStatus2 = '',
        drillDepth3 = '',
        oxygenTube3 = '',
        slagStatus3 = '',
        drillDepth4 = '',
        oxygenTube4 = '',
        slagStatus4 = '',
        drillDepth5 = '',
        oxygenTube5 = '',
        slagStatus5 = '',
        totalElectrodeDropStart = '',
        totalElectrodeDropEnd = '',
        electrodeDrop1 = '',
        electrodeDrop2 = '',
        electrodeDrop3 = '',
        preShiftCurrent1 = '',
        preShiftCurrentIndex1 = '',
        preShiftCurrent2 = '',
        preShiftCurrentIndex2 = '',
        preShiftCurrent3 = '',
        preShiftCurrentIndex3 = '',
        transformerVoltageIndex1 = '',
        transformerVoltageIndex2 = '',
        transformerVoltageIndex3 = '',
        recorderId = '',
        reviewerId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.productionDate = productionDate;
    this.locationId = locationId;
    this.furnaceId = furnaceId;
    this.shiftId = shiftId;
    this.avgPowerCost = avgPowerCost;
    this.tubeFeed1 = tubeFeed1;
    this.tubeFeed2 = tubeFeed2;
    this.tubeFeed3 = tubeFeed3;
    this.electrodeDiff1 = electrodeDiff1;
    this.electrodeDischarge1 = electrodeDischarge1;
    this.electrodeDiff2 = electrodeDiff2;
    this.electrodeDischarge2 = electrodeDischarge2;
    this.electrodeDiff3 = electrodeDiff3;
    this.electrodeDischarge3 = electrodeDischarge3;
    this.bottomTemp12Start = bottomTemp12Start;
    this.bottomTemp12End = bottomTemp12End;
    this.bottomTemp12Diff = bottomTemp12Diff;
    this.bottomTemp22Start = bottomTemp22Start;
    this.bottomTemp22End = bottomTemp22End;
    this.bottomTemp22Diff = bottomTemp22Diff;
    this.bottomTemp32Start = bottomTemp32Start;
    this.bottomTemp32End = bottomTemp32End;
    this.bottomTemp32Diff = bottomTemp32Diff;
    this.envTempStart = envTempStart;
    this.envTempEnd = envTempEnd;
    this.envTempDiff = envTempDiff;
    this.coverTemp414Start = coverTemp414Start;
    this.coverTemp414End = coverTemp414End;
    this.coverTemp414Diff = coverTemp414Diff;
    this.coverTemp424Start = coverTemp424Start;
    this.coverTemp424End = coverTemp424End;
    this.coverTemp424Diff = coverTemp424Diff;
    this.coverTemp434Start = coverTemp434Start;
    this.coverTemp434End = coverTemp434End;
    this.coverTemp434Diff = coverTemp434Diff;
    this.tapholeTemp150Start = tapholeTemp150Start;
    this.tapholeTemp150End = tapholeTemp150End;
    this.tapholeTemp150Diff = tapholeTemp150Diff;
    this.tapholeTemp152Start = tapholeTemp152Start;
    this.tapholeTemp152End = tapholeTemp152End;
    this.tapholeTemp152Diff = tapholeTemp152Diff;
    this.tapholeTemp153Start = tapholeTemp153Start;
    this.tapholeTemp153End = tapholeTemp153End;
    this.tapholeTemp153Diff = tapholeTemp153Diff;
    this.tapholeTemp155Start = tapholeTemp155Start;
    this.tapholeTemp155End = tapholeTemp155End;
    this.tapholeTemp155Diff = tapholeTemp155Diff;
    this.slagTemp250 = slagTemp250;
    this.slagTemp251 = slagTemp251;
    this.slagTemp252 = slagTemp252;
    this.slagTemp253 = slagTemp253;
    this.slagTemp254 = slagTemp254;
    this.slagTemp255 = slagTemp255;
    this.ironTemp131Start = ironTemp131Start;
    this.ironTemp131End = ironTemp131End;
    this.ironTemp131Diff = ironTemp131Diff;
    this.ironTemp132Start = ironTemp132Start;
    this.ironTemp132End = ironTemp132End;
    this.ironTemp132Diff = ironTemp132Diff;
    this.ironTemp133Start = ironTemp133Start;
    this.ironTemp133End = ironTemp133End;
    this.ironTemp133Diff = ironTemp133Diff;
    this.drillDepth1 = drillDepth1;
    this.oxygenTube1 = oxygenTube1;
    this.slagStatus1 = slagStatus1;
    this.drillDepth2 = drillDepth2;
    this.oxygenTube2 = oxygenTube2;
    this.slagStatus2 = slagStatus2;
    this.drillDepth3 = drillDepth3;
    this.oxygenTube3 = oxygenTube3;
    this.slagStatus3 = slagStatus3;
    this.drillDepth4 = drillDepth4;
    this.oxygenTube4 = oxygenTube4;
    this.slagStatus4 = slagStatus4;
    this.drillDepth5 = drillDepth5;
    this.oxygenTube5 = oxygenTube5;
    this.slagStatus5 = slagStatus5;
    this.totalElectrodeDropStart = totalElectrodeDropStart;
    this.totalElectrodeDropEnd = totalElectrodeDropEnd;
    this.electrodeDrop1 = electrodeDrop1;
    this.electrodeDrop2 = electrodeDrop2;
    this.electrodeDrop3 = electrodeDrop3;
    this.preShiftCurrent1 = preShiftCurrent1;
    this.preShiftCurrentIndex1 = preShiftCurrentIndex1;
    this.preShiftCurrent2 = preShiftCurrent2;
    this.preShiftCurrentIndex2 = preShiftCurrentIndex2;
    this.preShiftCurrent3 = preShiftCurrent3;
    this.preShiftCurrentIndex3 = preShiftCurrentIndex3;
    this.transformerVoltageIndex1 = transformerVoltageIndex1;
    this.transformerVoltageIndex2 = transformerVoltageIndex2;
    this.transformerVoltageIndex3 = transformerVoltageIndex3;
    this.recorderId = recorderId;
    this.reviewerId = reviewerId;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdSmeltingElectrodeDischarge();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'productionDate',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.productionDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.locationId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.furnaceId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'furnaceName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.furnaceName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.shiftId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'avgPowerCost',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.avgPowerCost',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tubeFeed1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tubeFeed1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tubeFeed2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tubeFeed2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tubeFeed3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tubeFeed3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDiff1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDiff1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDischarge1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDischarge1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDiff2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDiff2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDischarge2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDischarge2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDiff3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDiff3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDischarge3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDischarge3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp12Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp12Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp12End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp12End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp12Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp12Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp22Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp22Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp22End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp22End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp22Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp22Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp32Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp32Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp32End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp32End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'bottomTemp32Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.bottomTemp32Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'envTempStart',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.envTempStart',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'envTempEnd',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.envTempEnd',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'envTempDiff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.envTempDiff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp414Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp414Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp414End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp414End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp414Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp414Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp424Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp424Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp424End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp424End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp424Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp424Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp434Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp434Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp434End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp434End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'coverTemp434Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.coverTemp434Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp150Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp150Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp150End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp150End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp150Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp150Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp152Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp152Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp152End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp152End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp152Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp152Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp153Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp153Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp153End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp153End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp153Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp153Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp155Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp155Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp155End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp155End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'tapholeTemp155Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.tapholeTemp155Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagTemp250',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagTemp250',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagTemp251',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagTemp251',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagTemp252',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagTemp252',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagTemp253',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagTemp253',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagTemp254',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagTemp254',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagTemp255',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagTemp255',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp131Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp131Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp131End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp131End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp131Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp131Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp132Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp132Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp132End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp132End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp132Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp132Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp133Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp133Start',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp133End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp133End',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ironTemp133Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.ironTemp133Diff',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'drillDepth1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.drillDepth1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'oxygenTube1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.oxygenTube1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagStatus1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagStatus1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'drillDepth2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.drillDepth2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'oxygenTube2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.oxygenTube2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagStatus2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagStatus2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'drillDepth3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.drillDepth3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'oxygenTube3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.oxygenTube3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagStatus3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagStatus3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'drillDepth4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.drillDepth4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'oxygenTube4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.oxygenTube4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagStatus4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagStatus4',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'drillDepth5',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.drillDepth5',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'oxygenTube5',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.oxygenTube5',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'slagStatus5',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.slagStatus5',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'totalElectrodeDropStart',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.totalElectrodeDropStart',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'totalElectrodeDropEnd',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.totalElectrodeDropEnd',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDrop1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDrop1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDrop2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDrop2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'electrodeDrop3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.electrodeDrop3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'preShiftCurrent1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.preShiftCurrent1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'preShiftCurrentIndex1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.preShiftCurrentIndex1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'preShiftCurrent2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.preShiftCurrent2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'preShiftCurrentIndex2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.preShiftCurrentIndex2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'preShiftCurrent3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.preShiftCurrent3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'preShiftCurrentIndex3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.preShiftCurrentIndex3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'transformerVoltageIndex1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.transformerVoltageIndex1',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'transformerVoltageIndex2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.transformerVoltageIndex2',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'transformerVoltageIndex3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.transformerVoltageIndex3',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'recorderId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.recorderId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.reviewerId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    productionDateRteFilter : "",
    productionDateLteFilter : "",
    locationIdFilter : "",
    furnaceIdFilter : "",
    shiftIdFilter : "",
    avgPowerCostFilter : "",
    tubeFeed1Filter : "",
    tubeFeed2Filter : "",
    tubeFeed3Filter : "",
    electrodeDiff1Filter : "",
    electrodeDischarge1Filter : "",
    electrodeDiff2Filter : "",
    electrodeDischarge2Filter : "",
    electrodeDiff3Filter : "",
    electrodeDischarge3Filter : "",
    bottomTemp12StartFilter : "",
    bottomTemp12EndFilter : "",
    bottomTemp12DiffFilter : "",
    bottomTemp22StartFilter : "",
    bottomTemp22EndFilter : "",
    bottomTemp22DiffFilter : "",
    bottomTemp32StartFilter : "",
    bottomTemp32EndFilter : "",
    bottomTemp32DiffFilter : "",
    envTempStartFilter : "",
    envTempEndFilter : "",
    envTempDiffFilter : "",
    coverTemp414StartFilter : "",
    coverTemp414EndFilter : "",
    coverTemp414DiffFilter : "",
    coverTemp424StartFilter : "",
    coverTemp424EndFilter : "",
    coverTemp424DiffFilter : "",
    coverTemp434StartFilter : "",
    coverTemp434EndFilter : "",
    coverTemp434DiffFilter : "",
    tapholeTemp150StartFilter : "",
    tapholeTemp150EndFilter : "",
    tapholeTemp150DiffFilter : "",
    tapholeTemp152StartFilter : "",
    tapholeTemp152EndFilter : "",
    tapholeTemp152DiffFilter : "",
    tapholeTemp153StartFilter : "",
    tapholeTemp153EndFilter : "",
    tapholeTemp153DiffFilter : "",
    tapholeTemp155StartFilter : "",
    tapholeTemp155EndFilter : "",
    tapholeTemp155DiffFilter : "",
    slagTemp250Filter : "",
    slagTemp251Filter : "",
    slagTemp252Filter : "",
    slagTemp253Filter : "",
    slagTemp254Filter : "",
    slagTemp255Filter : "",
    ironTemp131StartFilter : "",
    ironTemp131EndFilter : "",
    ironTemp131DiffFilter : "",
    ironTemp132StartFilter : "",
    ironTemp132EndFilter : "",
    ironTemp132DiffFilter : "",
    ironTemp133StartFilter : "",
    ironTemp133EndFilter : "",
    ironTemp133DiffFilter : "",
    drillDepth1Filter : "",
    oxygenTube1Filter : "",
    slagStatus1Filter : "",
    drillDepth2Filter : "",
    oxygenTube2Filter : "",
    slagStatus2Filter : "",
    drillDepth3Filter : "",
    oxygenTube3Filter : "",
    slagStatus3Filter : "",
    drillDepth4Filter : "",
    oxygenTube4Filter : "",
    slagStatus4Filter : "",
    drillDepth5Filter : "",
    oxygenTube5Filter : "",
    slagStatus5Filter : "",
    totalElectrodeDropStartFilter : "",
    totalElectrodeDropEndFilter : "",
    electrodeDrop1Filter : "",
    electrodeDrop2Filter : "",
    electrodeDrop3Filter : "",
    preShiftCurrent1Filter : "",
    preShiftCurrentIndex1Filter : "",
    preShiftCurrent2Filter : "",
    preShiftCurrentIndex2Filter : "",
    preShiftCurrent3Filter : "",
    preShiftCurrentIndex3Filter : "",
    transformerVoltageIndex1Filter : "",
    transformerVoltageIndex2Filter : "",
    transformerVoltageIndex3Filter : "",
    recorderIdFilter : "",
    reviewerIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'productionDateRteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.filter.productionDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'productionDateLteFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.filter.productionDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'locationIdFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.filter.locationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'furnaceIdFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.filter.furnaceId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'shiftIdFilter',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.filter.shiftId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstShift'
            ,correspondingField: 'id'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'productionDate',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.productionDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'locationId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'furnaceId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.furnaceId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesMstFurnace'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'shiftId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.shiftId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstShift'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'avgPowerCost',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.avgPowerCost',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tubeFeed1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tubeFeed1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tubeFeed2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tubeFeed2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tubeFeed3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tubeFeed3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDiff1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDiff1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDischarge1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDischarge1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDiff2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDiff2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDischarge2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDischarge2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDiff3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDiff3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDischarge3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDischarge3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp12Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp12Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp12End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp12End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp12Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp12Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp22Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp22Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp22End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp22End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp22Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp22Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp32Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp32Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp32End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp32End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'bottomTemp32Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.bottomTemp32Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'envTempStart',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.envTempStart',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'envTempEnd',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.envTempEnd',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'envTempDiff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.envTempDiff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp414Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp414Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp414End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp414End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp414Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp414Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp424Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp424Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp424End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp424End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp424Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp424Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp434Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp434Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp434End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp434End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'coverTemp434Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.coverTemp434Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp150Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp150Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp150End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp150End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp150Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp150Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp152Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp152Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp152End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp152End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp152Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp152Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp153Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp153Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp153End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp153End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp153Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp153Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp155Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp155Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp155End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp155End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'tapholeTemp155Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.tapholeTemp155Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagTemp250',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagTemp250',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagTemp251',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagTemp251',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagTemp252',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagTemp252',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagTemp253',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagTemp253',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagTemp254',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagTemp254',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagTemp255',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagTemp255',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp131Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp131Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp131End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp131End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp131Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp131Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp132Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp132Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp132End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp132End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp132Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp132Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp133Start',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp133Start',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp133End',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp133End',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ironTemp133Diff',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.ironTemp133Diff',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'drillDepth1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.drillDepth1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'oxygenTube1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.oxygenTube1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagStatus1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagStatus1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'drillDepth2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.drillDepth2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'oxygenTube2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.oxygenTube2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagStatus2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagStatus2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'drillDepth3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.drillDepth3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'oxygenTube3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.oxygenTube3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagStatus3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagStatus3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'drillDepth4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.drillDepth4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'oxygenTube4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.oxygenTube4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagStatus4',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagStatus4',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'drillDepth5',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.drillDepth5',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'oxygenTube5',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.oxygenTube5',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'slagStatus5',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.slagStatus5',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'totalElectrodeDropStart',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.totalElectrodeDropStart',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'totalElectrodeDropEnd',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.totalElectrodeDropEnd',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDrop1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDrop1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDrop2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDrop2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'electrodeDrop3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.electrodeDrop3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'preShiftCurrent1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.preShiftCurrent1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'preShiftCurrentIndex1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.preShiftCurrentIndex1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'preShiftCurrent2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.preShiftCurrent2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'preShiftCurrentIndex2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.preShiftCurrentIndex2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'preShiftCurrent3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.preShiftCurrent3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'preShiftCurrentIndex3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.preShiftCurrentIndex3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'transformerVoltageIndex1',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.transformerVoltageIndex1',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'transformerVoltageIndex2',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.transformerVoltageIndex2',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'transformerVoltageIndex3',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.transformerVoltageIndex3',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'recorderId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.recorderId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'reviewerId',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.reviewerId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdSmeltingElectrodeDischarge.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesPrdSmeltingElectrodeDischarge, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
